
const digest = '2fc9bc662846bb0024d5c44b3057f7ac07c3cf31495569f2814489d3665e32cb';
const classes = {"container":"_container_1s4us_1"};
const css = `._container_1s4us_1 {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #d81616;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  